(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chewz-bundle-purchase-v2"] && !Shopify.designMode) return;
  try {
    (()=>{
if(window.czReachCountdownReady)return;
window.czReachCountdownReady=true;
const starts=new WeakMap(),observed=new WeakSet();
function tick(){document.querySelectorAll('[data-reach-countdown]').forEach(box=>{
if(!starts.has(box))return;
const elapsed=(Date.now()-starts.get(box))%25000;
const seconds=elapsed<20000?20-Math.floor(elapsed/1000):0;
box.querySelector('.cz-reach-time').textContent=String(seconds).padStart(2,'0');
box.toggleAttribute('data-zero',seconds===0);
});}
const observer=new IntersectionObserver(entries=>{
entries.forEach(entry=>{
if(!entry.isIntersecting||entry.intersectionRatio<0.25)return;
const box=entry.target;
if(!starts.has(box)){
starts.set(box,Date.now());
box.setAttribute('data-reach-started','');
}
observer.unobserve(box);
});
tick();
},{threshold:[0,0.25]});
function init(scope){scope.querySelectorAll('[data-reach-countdown]').forEach(box=>{
if(observed.has(box))return;
observed.add(box);
box.removeAttribute('data-reach-started');
box.removeAttribute('data-zero');
box.querySelector('.cz-reach-time').textContent='20';
observer.observe(box);
});}
init(document);
document.addEventListener('shopify:section:load',event=>init(event.target));
document.addEventListener('shopify:section:unload',event=>{
event.target.querySelectorAll('[data-reach-countdown]').forEach(box=>observer.unobserve(box));
});
setInterval(tick,200);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chewz-family-example-purchase"] && !Shopify.designMode) return;
  try {
    (()=>{
const starts=new WeakMap();
function tick(){document.querySelectorAll('[data-reach-countdown]').forEach(box=>{
if(!starts.has(box))starts.set(box,Date.now());
const elapsed=(Date.now()-starts.get(box))%25000;
const seconds=elapsed<20000?20-Math.floor(elapsed/1000):0;
box.querySelector('.cz-reach-time').textContent=String(seconds).padStart(2,'0');
box.toggleAttribute('data-zero',seconds===0);
});}
tick();setInterval(tick,200);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chewz-ritual-purchase"] && !Shopify.designMode) return;
  try {
    (()=>{
if(window.czReachCountdownReady)return;
window.czReachCountdownReady=true;
const starts=new WeakMap(),observed=new WeakSet();
function tick(){document.querySelectorAll('[data-reach-countdown]').forEach(box=>{
if(!starts.has(box))return;
const elapsed=(Date.now()-starts.get(box))%25000;
const seconds=elapsed<20000?20-Math.floor(elapsed/1000):0;
box.querySelector('.cz-reach-time').textContent=String(seconds).padStart(2,'0');
box.toggleAttribute('data-zero',seconds===0);
});}
const observer=new IntersectionObserver(entries=>{
entries.forEach(entry=>{
if(!entry.isIntersecting||entry.intersectionRatio<0.25)return;
const box=entry.target;
if(!starts.has(box)){
starts.set(box,Date.now());
box.setAttribute('data-reach-started','');
}
observer.unobserve(box);
});
tick();
},{threshold:[0,0.25]});
function init(scope){scope.querySelectorAll('[data-reach-countdown]').forEach(box=>{
if(observed.has(box))return;
observed.add(box);
box.removeAttribute('data-reach-started');
box.removeAttribute('data-zero');
box.querySelector('.cz-reach-time').textContent='20';
observer.observe(box);
});}
init(document);
document.addEventListener('shopify:section:load',event=>init(event.target));
document.addEventListener('shopify:section:unload',event=>{
event.target.querySelectorAll('[data-reach-countdown]').forEach(box=>observer.unobserve(box));
});
setInterval(tick,200);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chewz-stix-example-purchase"] && !Shopify.designMode) return;
  try {
    (()=>{
const starts=new WeakMap();
function tick(){document.querySelectorAll('[data-reach-countdown]').forEach(box=>{
if(!starts.has(box))starts.set(box,Date.now());
const elapsed=(Date.now()-starts.get(box))%25000;
const seconds=elapsed<20000?20-Math.floor(elapsed/1000):0;
box.querySelector('.cz-reach-time').textContent=String(seconds).padStart(2,'0');
box.toggleAttribute('data-zero',seconds===0);
});}
tick();setInterval(tick,200);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cz30-purchase"] && !Shopify.designMode) return;
  try {
    (()=>{
if(window.czReachCountdownReady)return;
window.czReachCountdownReady=true;
const starts=new WeakMap(),observed=new WeakSet();
function tick(){document.querySelectorAll('[data-reach-countdown]').forEach(box=>{
if(!starts.has(box))return;
const elapsed=(Date.now()-starts.get(box))%25000;
const seconds=elapsed<20000?20-Math.floor(elapsed/1000):0;
box.querySelector('.cz-reach-time').textContent=String(seconds).padStart(2,'0');
box.toggleAttribute('data-zero',seconds===0);
});}
const observer=new IntersectionObserver(entries=>{
entries.forEach(entry=>{
if(!entry.isIntersecting||entry.intersectionRatio<0.25)return;
const box=entry.target;
if(!starts.has(box)){
starts.set(box,Date.now());
box.setAttribute('data-reach-started','');
}
observer.unobserve(box);
});
tick();
},{threshold:[0,0.25]});
function init(scope){scope.querySelectorAll('[data-reach-countdown]').forEach(box=>{
if(observed.has(box))return;
observed.add(box);
box.removeAttribute('data-reach-started');
box.removeAttribute('data-zero');
box.querySelector('.cz-reach-time').textContent='20';
observer.observe(box);
});}
init(document);
document.addEventListener('shopify:section:load',event=>init(event.target));
document.addEventListener('shopify:section:unload',event=>{
event.target.querySelectorAll('[data-reach-countdown]').forEach(box=>observer.unobserve(box));
});
setInterval(tick,200);
})();
  } catch(e) { console.error(e); }
})();

})();
